export const sortArr = [
  {name: 'default', value: 'default'},
  {name: 'price: low to high', value: 'pricelow'},
  {name: 'price: high to low', value: 'pricehigh'},
  {name: 'rating', value: 'rating'},
  {name: 'popularity', value: 'popularity'},
]

export const categArr = [
  {name: 'all', value: 'all'},
  {name: 'women', value: 'women'},
  {name: 'men', value: 'men'},
  {name: 'kids', value: 'kids'},
]

export const priceArr = [
  {name: 'all', value: 'all'},
  {name: '$0 - $49', value: [0,49]},
  {name: '$50 - $99', value: [50,99]},
  {name: '$100 - $149', value: [100,149]},
  {name: '$150 - $249', value: [150,249]},
  {name: '$250 - $499', value: [250,499]},
  {name: '$500+', value: [500,Infinity]},
]

export const sizeArr = [
  {name: 'all', value: 'all'},
  {name: 'extra small', value: 'xs'},
  {name: 'small', value: 's'},
  {name: 'medium', value: 'm'},
  {name: 'large', value: 'l'},
  {name: 'extra large', value: 'xl'},
]

export const ratingsArr = [
  {name: 'all', value: 'all'},
  {name: '5 stars', value: 5},
  {name: '4 stars', value: 4},
  {name: '3 stars', value: 3},
  {name: '2 stars', value: 2},
  {name: '1 stars', value: 1},
]

export const colorsArr = [
  {name: 'all', value: 'all'},
  {name: 'black', value: '#222'},
  {name: 'red', value: '#ff174d'},
  {name: 'green', value: '#47d400'},
  {name: 'blue', value: '#00a2ff'},
  {name: 'orange', value: '#ff9100'},
  {name: 'yellow', value: '#ffea05'},
  {name: 'pink', value: '#edb5ff'},
  {name: 'gray', value: '#bdc6c7'},
]